module.exports = __webpack_public_path__ + "img/no-photo.299ea087.png";